import { Component, EventEmitter, Input, OnInit, Output, Pipe, PipeTransform } from '@angular/core';
import { VenueDetailsVisit } from '../venue-details.model';
import { EnumModel } from '../../../shared/objects/EnumModel';
import { AddNewCoverService } from './add-new-cover.service';
import { AddNewCoverMemberSearchPipe } from 'app/venues/venue-details/add-new-cover/add-new-cover-member-search.pipe';
import { DateHelper } from 'app/shared/helpers/date-helper';

@Component({
  selector: 'app-add-new-cover',
  templateUrl: './add-new-cover.component.html',
  styleUrls: ['./add-new-cover.component.less',
  ],
  providers: [AddNewCoverService, AddNewCoverMemberSearchPipe]
})
export class AddNewCoverComponent implements OnInit {
  @Input() venueType: string;
  @Input() initialRateBar: number;
  @Input() initialRateRestaurant: number;
  @Output() output = new EventEmitter<VenueDetailsVisit>();
  @Output() dissmiss = new EventEmitter();

  date: Date;
  minDate = new Date();
  maxDate = new Date();
  time = new Date();
  noOfCovers = 5;
  rate = 2;

  membershipNo: string;
  membershipOptions: any[];
  member: any;
  showMemberPicker = false;
  perk = false

  // for membership lookup
  searchString = '';

  typeOptions: Array<EnumModel>;
  type: EnumModel;

  constructor(private service: AddNewCoverService) {
    const now = new Date();
    if (new Date().getDate() < 5) {
      this.minDate = new Date(new Date().setMonth(now.getMonth() - 1));
      this.minDate.setDate(1);
    } else {
      this.minDate = new Date(now.getFullYear(), now.getMonth(), 1, now.getHours(), now.getMinutes());
    }

  }

  ngOnInit() {
    const firstRealMembershipIndex = 1;

    if (this.venueType) {
      if (this.venueType === 'Restaurant') {
        this.typeOptions = [new EnumModel('Restaurant', 'Restaurant')];
        this.rate = this.initialRateRestaurant;
      } else {
        this.typeOptions = [new EnumModel('Bar', 'Bar')];
        this.rate = this.initialRateBar;
      }
    } else {
      this.typeOptions = [new EnumModel('Restaurant', 'Restaurant'), new EnumModel('Bar', 'Bar')];
      this.rate = this.initialRateRestaurant;
    }
    this.type = this.typeOptions[0];

    this.service.getMembers().subscribe(
      (response) => {
        this.membershipOptions = response;
        this.selectMembershipNo(this.membershipOptions[firstRealMembershipIndex]);
      }
    );
    this.date = DateHelper.getLastDayOfPreviousMonth()
  }

  selectMembershipNo(member: any) {
    this.membershipNo = member.membershipNumber;
    this.member = member;
    this.showMemberPicker = false;
  }

  save() {
    const result = new VenueDetailsVisit();
    result.timeOfVisit = new Date(this.date.getFullYear(), this.date.getMonth(),
      this.date.getDate(), this.time.getHours(), this.time.getMinutes());
    result.type = this.type.id;
    result.memberId = this.member.id;
    result.partySize = this.noOfCovers;
    result.ratePerCover = this.rate;
    result.revenue = this.noOfCovers * this.rate;
    result.membershipNumber = this.membershipNo;
    result.memberName = this.member.name;
    result.editable = true;
    result.isPerkUsed = this.perk;
    this.output.emit(result);
  }

  setSearchString(str) {
    this.searchString = str;
  }

  close() {
    this.dissmiss.emit();
  }

  changeRate(value) {
    if (value === 'Restaurant') {
      this.rate = this.initialRateRestaurant;
    } else {
      this.rate = this.initialRateBar;
    }
  }
}






// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/venues/venue-details/add-new-cover/add-new-cover.component.ts